import React from 'react';
import { useCatalog } from '../../catalog';
import { resolveHeroImageUrl } from '../../utils/dotaAssets';
import { resolveHeroDisplayName } from '../../utils/dotaNames';
import { useImageLoad } from '../../utils/useImageLoad';
import '../cdn-img.css';
import './HeroIcon.css';

type HeroIconProps = {
  heroName?: string;
  /** Ширина иконки в px; высота — пропорционально (36x20). */
  width?: number;
};

const HeroIcon: React.FC<HeroIconProps> = ({ heroName, width = 36 }) => {
  const catalog = useCatalog();
  const imageUrl = heroName ? resolveHeroImageUrl(catalog, heroName) : '';
  const heroLabel = heroName ? resolveHeroDisplayName(catalog, heroName) : '';
  const { ref, loaded, failed, onLoad, onError } = useImageLoad(imageUrl || undefined);
  const style: React.CSSProperties = { width, height: Math.round(width * 20 / 36) };

  if (imageUrl && !failed) {
    return (
      <img
        ref={ref}
        src={imageUrl}
        alt=""
        style={style}
        className={`hero-icon cdn-img${loaded ? ' cdn-img--loaded' : ''}`}
        decoding="async"
        onLoad={onLoad}
        onError={onError}
      />
    );
  }
  return heroLabel ? <span style={style} className="hero-icon hero-icon-fallback">{heroLabel.slice(0, 2)}</span> : null;
};

export default HeroIcon;
